import React from 'react';
import {fuzzyMatchHighlight} from '../../util/fuzzyMatch';
import makeComp from '../../util/profiler';

interface PanelTitleProps {
  title: string;
  searchQuery?: string;
}

const PanelTitle: React.FC<PanelTitleProps> = makeComp(
  props => {
    return (
      <h6 className="panel-title" title={props.title}>
        {props.searchQuery
          ? fuzzyMatchHighlight(props.title, props.searchQuery)
          : props.title}
      </h6>
    );
  },
  {id: 'PanelTitle'}
);

export default PanelTitle;
